import { useEffect } from "react";
import { matchPath } from "react-router";
import { useAppDispatch, useAppSelector } from "src/store/hooks";

// Assets
import Logo from "src/assets/images/icom-logo-azul.png";
import DarkLogo from "src/assets/images/icom-logo-branco.png";

// Actions
import { userLogout } from "src/store/auth/actions";

// Components
import NavItem from "./components/nav-item";

// Assets
import { House, History, Cog, Magnify, Exit } from "src/assets/svgs";
import { toggleSidebar } from "src/store/context/reducer";
import Swal from "sweetalert2";

export default function Sidebar() {
  const dispatch = useAppDispatch();
  const { sidebar, sidebarCollapsed } = useAppSelector((state) => state.context);
  const { general } = useAppSelector((state) => state.config);
  const currentLogoTheme = general.theme === "dark" ? DarkLogo : Logo;
  // Logout
  const logoutAction = async () => {
    const result = await Swal.fire({
      title: `Efetuar logout`,
      text: `Confirmar?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: `Sim`,
      cancelButtonText: "Não",
    });

    if (!result.isConfirmed) return false;
    return dispatch(userLogout(true));
  };

  useEffect(() => {}, [general.theme]);

  return (
    <aside className={`main-sidebar dark:bg-neutral-gray-800 sidebar bg-neutral-gray-5 ${sidebarCollapsed ? "w-fit" : "w-[300px]"} h-full flex flex-col p-8 gap-8`}>
      <img src={currentLogoTheme} width={73} alt="Logo Icom" className="logo-icom mb-6" />

      <nav className="mb-2">
        <ul className="">
          <NavItem Icon={House} to="/" active={!sidebar && !!matchPath("/", location.pathname)}>
            {!sidebarCollapsed && "Início"}
          </NavItem>

          <NavItem Icon={Cog} to="/config" active={!!matchPath("/config", location.pathname)}>
            {!sidebarCollapsed && "Configurações"}
          </NavItem>

          <NavItem active={sidebar === "searchUsers"} Icon={Magnify} onClick={() => dispatch(toggleSidebar("searchUsers"))}>
            {!sidebarCollapsed && "Buscar usuário"}
          </NavItem>

          <NavItem active={sidebar === "callHistory"} Icon={History} onClick={() => dispatch(toggleSidebar("callHistory"))}>
            {!sidebarCollapsed && "Histórico"}
          </NavItem>
        </ul>
      </nav>

      <nav className="mt-auto">
        <ul className="">
          <NavItem onClick={logoutAction}>
            <Exit className="fill-inherit" /> {!sidebarCollapsed && "Sair"}
          </NavItem>
        </ul>
      </nav>
    </aside>
  );
}
